/**
 * Stable JSON string for React Query keys so filter objects with the same
 * entries invalidate together regardless of key insertion order.
 */
export function stableSerializeRecord (record: undefined | Record<string, unknown>): string {
  if (record == null) return ''
  const keys = Object.keys(record).sort()
  if (keys.length === 0) return ''
  const sorted: Record<string, unknown> = {}
  for (const k of keys) {
    sorted[k] = record[k]
  }
  return JSON.stringify(sorted)
}
